// extracted by mini-css-extract-plugin
module.exports = {"lia-list-body":"TagWidget_lia-list-body__vZu3p","lia-list-header":"TagWidget_lia-list-header__tR24D","lia-modal-filter-wrap":"TagWidget_lia-modal-filter-wrap__Tn8BI"};